import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PdfReportService {

    constructor(private apiService: ApiService) {
    }

    public getReportPdf(data: { year?: number, period?: number; userId?: number; companyId?: number }) {
        return this.apiService.getBlobCall(`registrations/report/pdf`, data);
    }

    public postPdfUnderlay(file: File) {
        return this.apiService.makeFileRequest$<Blob>(`registrations/pdf/underlay`, file, false).pipe(
            map(response => response as unknown as Blob)
        );
    }
}
